export default __webpack_public_path__ + "static/media/1bus.88c556a5.jpg";